import React from 'react'

export const CarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.9 8.16667H14.3C14.72 8.16667 15 7.9 15 7.5V5.5C15 4.9 14.51 4.36667 13.95 4.23333C12.69 3.9 10.8 3.5 10.8 3.5C10.8 3.5 9.89 2.56667 9.26 1.96667C8.91 1.7 8.49 1.5 8 1.5H3.1C2.68 1.5 2.33 1.76667 2.12 2.1L1.14 4.03333C1.04731 4.29082 1 4.56114 1 4.83333V7.5C1 7.9 1.28 8.16667 1.7 8.16667H3.1M12.9 8.16667C12.9 8.90305 12.2732 9.5 11.5 9.5C10.7268 9.5 10.1 8.90305 10.1 8.16667M12.9 8.16667C12.9 7.43029 12.2732 6.83333 11.5 6.83333C10.7268 6.83333 10.1 7.43029 10.1 8.16667M3.1 8.16667C3.1 8.90305 3.7268 9.5 4.5 9.5C5.2732 9.5 5.9 8.90305 5.9 8.16667M3.1 8.16667C3.1 7.43029 3.7268 6.83333 4.5 6.83333C5.2732 6.83333 5.9 7.43029 5.9 8.16667M5.9 8.16667H10.1"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
